import React, { useState, useEffect } from 'react';
import './InstallButton.css';
import InstallModal from './InstallModal';

const InstallButton = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstallable, setIsInstallable] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const isStandalone = () => {
      const mediaStandalone = window.matchMedia('(display-mode: standalone)').matches;
      const iosStandalone = window.navigator.standalone === true;
      return mediaStandalone || iosStandalone;
    };

    // Check if app is already installed / running as PWA
    if (isStandalone()) {
      setIsInstalled(true);
    } else {
      setIsInstalled(false);
    }

    // Listen for beforeinstallprompt event
    const handleBeforeInstallPrompt = (e) => {
      console.log('[InstallButton] ✅ beforeinstallprompt event fired!', e);
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Save the event so it can be triggered later
      setDeferredPrompt(e);
      // Show install button
      setIsInstallable(true);
      console.log('[InstallButton] Set isInstallable=true, button should show now');
    };

    // Listen for app installed event
    const handleAppInstalled = () => {
      console.log('[Install] App was installed');
      setIsInstalled(true);
      setIsInstallable(false);
      setDeferredPrompt(null);
      setShowModal(false);
    };

    const handleVisibilityChange = () => {
      // Re-check install state when returning to the tab
      setIsInstalled(isStandalone());
    };

    const handleResize = () => {
      // Re-listen for beforeinstallprompt when viewport changes (e.g., DevTools mobile view)
      // This ensures the prompt is captured when toggling device emulation
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);
    window.addEventListener('focus', handleVisibilityChange);
    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
      window.removeEventListener('focus', handleVisibilityChange);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleInstallClick = () => {
    console.log('[InstallButton] Install button clicked');
    setShowModal(true);
  };

  const handleInstallNow = async () => {
    if (!deferredPrompt) {
      console.log('[InstallButton] Install prompt not available');
      return;
    }

    // Show the install prompt
    deferredPrompt.prompt();

    // Wait for the user to respond to the prompt
    const choiceResult = await deferredPrompt.userChoice;

    if (choiceResult.outcome === 'accepted') {
      console.log('[InstallButton] User accepted the install prompt');
    } else {
      console.log('[InstallButton] User dismissed the install prompt');
    }

    // Clear the prompt so a fresh one can be captured later
    setDeferredPrompt(null);
    setShowModal(false);
  };

  const handleResetInstall = async () => {
    try {
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map((registration) => registration.unregister()));
      }

      if (window.caches) {
        const cacheKeys = await caches.keys();
        await Promise.all(cacheKeys.map((key) => caches.delete(key)));
      }
    } catch (error) {
      console.warn('[InstallButton] Reset failed:', error);
    }

    window.location.reload();
  };

  // Don't show button if app is already opened in standalone mode
  if (isInstalled) {
    return null;
  }

  // Always show button on browser site (even if not installable yet)

  return (
    <>
      <button 
        className="install-pwa-btn"
        onClick={handleInstallClick}
        title="ऐप डाउनलोड करें"
      >
        <span className="install-icon">📱</span>
        <span className="install-text">ऐप डाउनलोड करें</span>
      </button>
      
      <InstallModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onInstall={handleInstallNow}
        canInstall={Boolean(deferredPrompt)}
        onReload={handleResetInstall}
      />
    </>
  );
};

export default InstallButton;
